import { Box } from '@wix/design-system';
import CardInfo from '../CardInfo';
import TemplateCardImage from '../TemplateCardImage';
import { TemplateGalleryCard } from '@common/types';
import s from '../TemplateCard.module.scss';

interface LoadedTemplateCardProps {
  template: TemplateGalleryCard;
  index: number;
  hover: boolean;
  setHover: React.Dispatch<React.SetStateAction<boolean>>;
}

const TemplateLoadedCard = ({
  template,
  index,
  hover,
  setHover,
}: LoadedTemplateCardProps) => {
  return (
    <Box
      className={s.template}
      direction="vertical"
      minWidth="232px"
      minHeight="322px"
      overflow="hidden"
      borderRadius="4px"
      verticalAlign="middle"
      dataHook="desktop-card"
    >
      <TemplateCardImage
        imageSource={template.media?.longThumbnail?.url}
        description={template.media?.longThumbnail?.description ?? ''}
        index={index}
        animatedPreview={template.media?.animatedPreview}
        hovered={hover}
      />
      <div onMouseEnter={() => setHover(true)}>
        <Box paddingTop="12px" display="block">
          <CardInfo template={template} isMobileView={false} hovered={hover} />
        </Box>
      </div>
    </Box>
  );
};

export default TemplateLoadedCard;
